<template>
  <BaseNoticeItem :button-text="$t('Update location')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Onsite presence required') }}</strong>
    </template>
    <template #body>
      <p>
        {{
          $t(
            'This job is onsite. To accept this job, you must be based in the country where the job is located.',
          )
        }}
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#account-setup`
})
</script>
